<div class="check-ins-container">
  <div class="time-of-day-filters">
    <cb-schedule-chip [type]="'multiple'" [defaultBorderColor]="true" />
    <cb-schedule-chip [type]="'morning'" [defaultBorderColor]="true" />
    <cb-schedule-chip [type]="'afternoon'" [defaultBorderColor]="true" />
    <cb-schedule-chip [type]="'evening'" [defaultBorderColor]="true" />
    <cb-schedule-chip [type]="'night'" [defaultBorderColor]="true" />
  </div>

  <p class="instructions">Click the buttons below to choose when you'll do the activity.</p>

  <div class="tasks-list">
    @for (item of tasksWithSchedules(); track item.task._id) {
      <div class="task-card">
        <div class="task-header">
          <cb-task-icon-button
            [icon]="getTaskIcon(item.task._id || '')"
            [taskId]="item.task._id || ''"
            [projectId]="cbProject()?._id || ''"
            (iconChange)="onTaskIconChange(item.task._id || '', $event)"
          />
          <div class="task-title">
            <div class="task-goal">{{ getGoalName() }}</div>
            <div class="task-name">{{ item.task.name }}</div>
          </div>
        </div>

        <div class="schedule-grid gtc-{{ cycleLength() }}">
          @for (scheduleItem of item.schedule; track scheduleItem.label + (scheduleItem.type || ''); let i = $index) {
            <div class="schedule-column">
              <div class="schedule-label">{{ scheduleItem.label }}</div>
              <cb-schedule-chip
                [type]="scheduleItem.type"
                [iconOnly]="true"
                [menu]="true"
                (selectType)="onScheduleSelect(item.task._id || '', i, $event)"
              />
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
